import AuthLayout from "@/views/LayoutView/AuthLayout.vue";

import Login from "@/views/AuthView/Login.vue";
import Register from "@/views/AuthView/Register.vue";
import LoginLoading from "@/views/AuthView/LoginLoading.vue";
import SignupLoading from "@/views/AuthView/SignupLoading.vue";
import TemporaryPassword from "@/views/AuthView/TemporaryPassword.vue";

const authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "login",
      name: "Login",
      component: Login,
      meta: { title: "topnav.login" },
    },
    {
      path: "register",
      name: "Register",
      component: Register,
      meta: { title: "topnav.register" },
    },
    {
      path: ":provider/login/authorization",
      name: "login-loading",
      component: LoginLoading,
      props: true,
      meta: { title: "topnav.login" },
    },
    {
      path: ":provider/signup/authorization",
      name: "signup-loading",
      component: SignupLoading,
      props: true,
      meta: { title: "topnav.register" },
    },
    {
      path: "forgot-password",
      name: "forgot-password",
      component: TemporaryPassword,
      meta: { title: "topnav.forgot_password" },
    },
  ],
};

export default authPages;
